const HT_TOKEN = '226345edc7ae6f48e21d40d78898be15';

const addScript = () => {
  const script = document.createElement('script');
  script.src = `//api.handtalk.me/plugin/latest/handtalk.min.js`;
  script.onload = () => {
    new HT({
      token: HT_TOKEN,
      doNotTrack: 'true',
    })
  };
  document.body.appendChild(script);
};

export const addHandTalk = () => {
  addScript();
};